export class Address {
	id: number;
	name: string;
	postalCode: string;
	town: string;
	streetNumber: number;
	street: string;
	details: string;
	latitude: number;
	longitude: number;
	formattedAddress: string;
	precision: string;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/Address.ts